import React from 'react'

class Logo extends React.Component {
    render() {
        return (
            <div className='logo' style={{ fontSize: '32px', display: "flex", justifyContent: "space-around", alignItems: "center" }}>
                <div style={{ borderRadius: '12px', height: "24px", width: "24px", border: "3px solid #0052d9", boxSizing: "border-box", marginRight: '2px', color: "black" }}></div><div>HTTPS</div>
            </div>
        )
    }
}

export default Logo;
